import { register } from "@vetty/api-sdk";
import { axiosInstance } from "@/helpers";
import { mapSafeRegisterError } from "@/helpers/register-error.helper";

type RegisterPayload =
  | {
      account: {
        email: string;
        password: string;
        confirmPassword: string;
        phoneNumber?: string | null;
        accountType?: "default" | "google";
      };
      profile: {
        firstName: string;
        lastName: string;
        locale?: string;
        displayName?: string | null;
        organizationName?: string | null;
        country?: string;
        utmSource?: string;
      };
      consent?: {
        acceptTerms: boolean;
        acceptPrivacy?: boolean;
        newsletter?: boolean;
      };
      silent?: boolean;
      attribution?: {
        click_id_type: "gclid" | "gbraid" | "wbraid";
        click_id_value: string;
        click_id_at: number;
      } | null;
      meta?: {
        eventId: string;
        marketingConsent: boolean;
        fbp?: string;
        fbc?: string;
        eventSourceUrl?: string;
        value?: number;
        currency?: string;
      };
    }
  | {
      /** @deprecated Prefer nested `account` + `profile`; kept for compatibility. */
      firstName: string;
      lastName: string;
      email: string;
      password: string;
      confirmPassword: string;
    };

const registerUser = async (payload: RegisterPayload) => {
  try {
    await register(axiosInstance, payload as never);
    return { ok: true as const };
  } catch (error: unknown) {
    const body =
      error && typeof error === "object" && "response" in error
        ? (error as { response?: { data?: { code?: string; message?: string; data?: unknown } } })
            .response?.data
        : undefined;
    const mapped = mapSafeRegisterError(body);
    return {
      ok: false as const,
      code: mapped.code,
      message: mapped.message,
    };
  }
};

export { registerUser };
